import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

interface EndGameSVGProps {
  bgFill?: string
  iconFill?: string
}

export const EndGameSVG = ({
  bgFill = Palette['Brand/Cream'],
  iconFill = Palette['Global/Black'],
  ...rest
}: React.ComponentProps<typeof Svg> & EndGameSVGProps) => (
  <Svg width={25} height={24} viewBox="0 0 25 24" fill="none" {...rest}>
    <G clipPath="url(#clip0_8684_899)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 24C18.8774 24 24.25 18.6274 24.25 12C24.25 5.37258 18.8774 0 12.25 0C5.62258 0 0.25 5.37258 0.25 12C0.25 18.6274 5.62258 24 12.25 24ZM6.25 11.25C5.83579 11.25 5.5 11.5858 5.5 12C5.5 12.4142 5.83579 12.75 6.25 12.75H18.25C18.6642 12.75 19 12.4142 19 12C19 11.5858 18.6642 11.25 18.25 11.25H6.25Z"
        fill={iconFill}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8684_899">
        <Rect width={24} height={24} fill={bgFill} transform="translate(0.25)" />
      </ClipPath>
    </Defs>
  </Svg>
)
